import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zkxww4gtng: FaireBrandEntity = {
  token: "b_zkxww4gtng",
  type: "brand",
  name: "Chunky Charms",
  avatarUrl:
    "https://cdn.faire.com/fastly/0f48b822b1ff767a9b89077ebaca4191b78f3524d5b8a5562ef50e93561891bb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4ee9974cd9bc936eb01f52e308f6095db88fcc25b6bdca53c353deb6a664dc37.png",
  logoUrl:
    "https://cdn.faire.com/fastly/0f48b822b1ff767a9b89077ebaca4191b78f3524d5b8a5562ef50e93561891bb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ee9974cd9bc936eb01f52e308f6095db88fcc25b6bdca53c353deb6a664dc37.png",
  location: "Ryan, OK, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Chunky Charms was created by a mom and daughter in 2005 that were looking for something fun to do together.  It has expanded into a business that we love!\n​\nStacie is the mom and the Gigsi! She is the brains behind the creativity and fun flair that you see added to each of your items.  She is a wife of 34 years, mom to 3 grown kids and the Gigsi to 7-almost 8 adorable grandbabies!\n​\nMagen is the daughter.  She is the control behind the scenes amongst the creativity of Stacie. She is a full-time high school teacher, coach's wife, and mom to 3 wild kids. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:47.435Z",
    importedBy: "entity-db-cli",
  },
};
